import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ScrollRendererImplementation from './ScrollRendererImplementation';

const ScrollRenderer = ({ children, ...props }) => {
    const initialState =
        !__SERVER__ &&
        'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
        'isIntersecting' in window.IntersectionObserverEntry.prototype;

    const [intersectionObserverExist, setIntersectionObserverExist] = useState(initialState);
    /* istanbul ignore next */
    useEffect(() => {
        if (!intersectionObserverExist) {
            import(
                /* webpackChunkName: "intersectionObserver" */ 'intersection-observer'
            ).then(() => setIntersectionObserverExist(true));
        }
    }, []);

    return intersectionObserverExist ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ScrollRendererImplementation {...props}>{children}</ScrollRendererImplementation>
    ) : null;
};

ScrollRenderer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
ScrollRenderer.defaultProps = {};

export default ScrollRenderer;
